import React, { useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import Switch from "react-switch";

import { BackIcon, Container, DetailView, SkillCircle } from "./styles";
import {
  BoldHeading,
  BoldLg,
  HorizontalLeftAlign,
  RegLg,
  SpaceBetween,
} from "../../../../Components/CustomStyles";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import IconButton from "../../../../Components/IconButton";
import MasKInput from "../../../../Components/IconInputField";
import {
  getAdminsRequest,
  patchCourseRequest,
  postCourseRequest,
  stripeOnboardRequest,
} from "../../../../Redux/actions/home";
import images from "../../../../Constant/images";
import Colors from "../../../../Constant/Colors";
import { FONTS, STYLES } from "../../../../Constant/Theme";
import CalendarComponent from "../../../../Components/Calendar";
import dayjs from "dayjs";
import CustomSelect from "../../../../Components/CustomSelect";
import Dropdown from "../../../../Components/DropDownPop";
import ModalComponent from "../../../../Components/Modal";
import CustomText from "../../../../Components/Text";
import SmartImage from "../../../../Components/SmartImage";
import { getProfileRequest } from "../../../../Redux/actions/auth";
import { FileUploader } from "react-drag-drop-files";
import { toast } from "react-toastify";
import axios from "axios";


const NewCourse = ({ handleView, course }) => {
  const dispatch = useDispatch();
  const {
    folders,
    adminList,
    isCourseCreated,
    coursesErrors,
    slugList,
    courseLoading,
  } = useSelector((state) => state.home);
  let { isCardAdded, token } = useSelector((state) => state.auth);

  let skills = [1, 2, 3, 4, 5];
  let [banner, setBanner] = useState(null);
  let [skill, setSkill] = useState(1);
  let [folderOptions, setFolderOptions] = useState([]);
  let [slugOptions, setSlugOptions] = useState([]);
  let [openPopup, setOpenPopup] = useState({
    item: {},
    isOpen: false,
    addCard: false,
    addImg: false,
  });
  const fileTypes = ["JPG", "PNG"];

  const [openCalendar, setOpenCalendar] = useState({
    isOpen: false,
    type: "",
  });

  const [onUploadProgress, setUploadProgress] = useState({
    count: 0,
    isStart: false,
  });

  const closeModal = () => {
    setOpenPopup({
      item: {},
      isOpen: false,
      addCard: false,
    });
    setOpenCalendar({ type: "", isOpen: false });
    if (openPopup.addCard) formik.setFieldValue("paid", false);
  };

  const sendTo = () => {
    setOpenPopup({
      item: {},
      isOpen: false,
    });
    formik.handleSubmit();
  };
  const openModal = (type) => setOpenCalendar({ type, isOpen: true });

  const handleDate = (e) => {
    if (openCalendar.type === "end") {
      formik.setFieldValue("end_date", e);
      closeModal();
    } else {
      formik.setFieldValue("start_date", e);
      closeModal();
    }
  };

  // const sendForApproval = () =>

  const initialValues = {
    title: "",
    subject: "",
    slug: 0,
    description: "",
    certificate: "",
    prerequisite: "",
    credit_hours: 0,
    start_date: "",
    end_date: "",
    folder_name: "",
    // paid: false,
    price: 0,
    auto_enrollment: false,
  };

  const validationSchema = yup.object().shape({
    title: yup.string().required("Please enter Course title"),
    subject: yup.string().required("Please enter subject"),
    slug: yup.string().required("Please enter slug"),
    description: yup.string().required("Please enter description"),
    prerequisite: yup.string().required("Please enter prerequisite"),
    credit_hours: yup
      .number()
      .required("Please enter credit hours")
      .positive("Credit hours must be greater than 0 hours"),
    certificate: yup.string().required("Please enter certificate"),
    folder_name: yup.string().required("Please select folder"),
    start_date: yup.string().required("Please select course start date"),
    end_date: yup
      .string()
      .required("Please select course end date")
      .test(
        "is-greater",
        "End date must be greater than start date",
        function (value) {
          const { start_date } = this.parent;
          return start_date && value && new Date(value) >= new Date(start_date);
        }
      ),
    // price: yup.number(),
    price: yup
      .number()
      .test("price-validation", "Please enter a valid price", function (value) {
        const { paid } = this.parent;
        if (paid) {
          return value != null && value > 0;
        }
        return true; // No validation if 'paid' is not true
      }),
  });

  const onSubmit = (values) => {
    let data = values;
    data["skill_level"] = skill;
    if (course?.id) {
      data["course_id"] = course?.id;
      data["folder"] = data.folder_id;
      let slug_id = slugOptions.find((f) => f.label === course?.slug)?.id;
      data["slug"] = slug_id;
      dispatch(patchCourseRequest(data));
    } else {
      dispatch(postCourseRequest(data));
    }
  };
  const onSelectAdmin = (item) => {
    setOpenPopup({
      item,
      isOpen: true,
    });
    let arr = [];
    item.forEach((fe) => arr.push(fe.id));
    formik.setFieldValue("admins", arr);
  };

  const formik = useFormik({ initialValues, validationSchema, onSubmit });

  // console.log('values', formik.values);

  const getError = (field) => {
    if (formik.touched[field] && formik.errors[field]) {
      if (Array.isArray(formik.errors[field])) {
        return formik.errors[field][0]; // return the first error in the array
      }
      return formik.errors[field]; // return the error string
    }
    return null;
  };


  const handleFolder = (obj) => {
    setTimeout(() => {
      formik.setFieldValue("folder_name", obj.value);
      formik.setFieldValue("folder_id", obj.id);
    }, 10);
  };

  const handleSlug = (obj) => formik.setFieldValue("slug", obj.id);

  const styles = {
    main: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      alignSelf: "center",
      flexDirection: "column",
    },
    container: {
      width: "90%",
      minWidth: 300,
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "space-between",
    },

    mainStyle: {
      width: "49%",
      minWidth: 260,
    },
    img: {
      border: "1px solid #6663",
      borderRadius: 8,
      padding: 5,
      cursor: "pointer",
      width: "45%",
      marginTop: 10,
      height: 123,
      marginBottom: 10,
    },
  };
  const handleBack = () => handleView("list");
  const handleSwitch = () => {
    if (!isCardAdded) {
      setOpenPopup((prev) => ({
        ...prev,
        addCard: true,
      }));
    }
    formik.setFieldValue("paid", !formik.values.paid);
  };
 

  const fileInputRef = useRef(null);

  const handleDivClick = () => {
    fileInputRef.current.click();
  };
  const onImgOpen = () => {
    setOpenPopup((prev) => ({
      ...prev,
      addImg: true,
    }));
  };
  const handleImageChange = async (img) => {
    // e.preventDefault();
    const file = img;
    if (!file) return;

    const imageUrl = await uploadFileToS3(file);
    
    setBanner(imageUrl);
    formik.setFieldValue("banner", imageUrl);
    closeModal();
  };

  const uploadFileToS3 = async (file) => {
    if (!file) return;

    let fileName = file.name;
    const fileType = file.type;
    fileName = fileName.replace(/ /g, "_");

    // Step 1: Request presigned URL from backend
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/course/content/s3/url/`,
      {
        file_name: fileName,
        file_type: fileType,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const presignedUrl = data.url;

    // Step 2: Upload the file directly to S3 using the presigned URL
    await axios.put(presignedUrl, file, {
      headers: {
        "Content-Type": fileType,
      },
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        if (percentCompleted === 100) {
          setUploadProgress({ isStart: false, count: percentCompleted });
        } else {
          setUploadProgress({ isStart: true, count: percentCompleted });
        }
      },
    });

    // Step 3: After successful upload, save the file URL in the backend (Optional)
    const fileUrl = `https://e-learning-s3.s3.amazonaws.com/media/content/${fileName}`;

    return fileUrl;
  };

  useEffect(() => {
    if (!adminList.length) dispatch(getAdminsRequest());
  }, []);

  useEffect(() => {
    if (coursesErrors && Object.keys(coursesErrors).length) {
      formik.setErrors(coursesErrors);
    }
  }, [coursesErrors]);

  useEffect(() => {
    if (isCourseCreated) {
      handleView("list");
    }
  }, [isCourseCreated]);

  useEffect(() => {
    if (folders.length) {
      let arr = [];
      folders.forEach((fe) => {
        let data = {
          id: fe.id,
          value: fe.folder_name,
          label: fe.folder_name,
        };
        arr.push(data);
      });
      setFolderOptions(arr);
    }
  }, [folders]);

  useEffect(() => {
    if (slugList.length) {
      let arr = [];
      slugList.forEach((fe) => {
        let data = {
          id: fe.id,
          value: fe.title,
          label: fe.title,
        };
        arr.push(data);
      });
      setSlugOptions(arr);
    }
  }, [slugList]);

  useEffect(() => {
    if (course?.id) {
      setSkill(course?.skill_level);
      formik.setFieldValue("title", course?.title);
      formik.setFieldValue("subject", course?.subject);
      formik.setFieldValue("skill_level", course?.skill_level);
      formik.setFieldValue("slug", course?.slug);
      formik.setFieldValue("description", course?.description);
      formik.setFieldValue("prerequisite", course?.prerequisite);
      formik.setFieldValue("certificate", course?.certificate);
      formik.setFieldValue("credit_hours", course?.credit_hours);
      formik.setFieldValue("start_date", course?.start_date);
      formik.setFieldValue("end_date", course?.end_date);
      formik.setFieldValue("folder_id", course?.folder?.id);
      formik.setFieldValue("folder_name", course?.folder?.title);
      formik.setFieldValue("price", course?.price);
      formik.setFieldValue("auto_enrollment", course?.auto_enrollment);
    } else {
      dispatch(getProfileRequest());
    }
  }, [course]);
  // console.log("slugOptions", slugOptions, course);

  return (
    <Container>
      <SpaceBetween style={{ marginTop: 10, marginBottom: 10 }}>
        <HorizontalLeftAlign>
          <BackIcon onClick={handleBack}>
            <KeyboardBackspaceIcon style={{ marginBottom: -8 }} />
          </BackIcon>
          <BoldLg>
            {course?.id ? `Edit ${course?.title} Course` : "Create New Course"} <span style={{color:Colors.primary}}> {formik.values.paid ? "(Paid)" : "(Free)"}
            </span></BoldLg>
        </HorizontalLeftAlign>
        <div>
          {course?.id || !isCardAdded ? (
            <></>
          ) : (
            <HorizontalLeftAlign>
              <BoldLg style={{ marginRight: 5 }}>Paid Course</BoldLg>
              <Switch
                checked={formik.values.paid}
                offColor={Colors.lightGrayColor2}
                onChange={handleSwitch}
                onColor={Colors.primary}
                height={25}
              />
            </HorizontalLeftAlign>
          )}
        </div>
      </SpaceBetween>

      <DetailView>
        <BoldHeading
          style={{
            textTransform: "capitalize",
            ...FONTS.Bold16,
            color: Colors.primary,
          }}
        >
          Course Banner
        </BoldHeading>
      
        <div onClick={onImgOpen} style={styles.img}>
          <SmartImage
            src={
              banner
                ? banner
                : course?.id && course?.banner
                ? course?.banner
                : images.plus
            }
            style={{
              height: "100%",
              width: "100%",
              backgroundColor: Colors.darkWhite,
            }}
            resizeMode="stretch"
          />
        </div>
        <MasKInput
          text={"Course Title"}
          name="title"
          placeholder="Course Title"
          onBlur={formik.handleBlur}
          mainStyle={styles.mainStyle}
          error={getError("title")}
          value={formik.values.title}
          style={{ marginRight: 10 }}
          onChangeText={(name, e) => formik.setFieldValue(name, e)}
          maxLength={20}
        />
        <MasKInput
          text={"Subject"}
          name="subject"
          placeholder="Subject"
          onBlur={formik.handleBlur}
          mainStyle={styles.mainStyle}
          error={getError("subject")}
          value={formik.values.subject}
          style={{ marginRight: 10 }}
          maxLength={20}
          onChangeText={(name, e) => formik.setFieldValue(name, e)}
        />
        <div style={{ height: 88 }}>
          <BoldHeading
            style={{
              textTransform: "capitalize",
              ...FONTS.Bold16,
              color: Colors.primary,
            }}
          >
            Skill Level
          </BoldHeading>
          <HorizontalLeftAlign style={{ padding: 10, marginTop: 12 }}>
            {skills.map((e, i) => (
              <SkillCircle
                style={{ cursor: "pointer" }}
                skill={skill}
                index={i}
                onClick={() => setSkill(e)}
              ></SkillCircle>
            ))}
          </HorizontalLeftAlign>
        </div>

        <BoldHeading
          style={{
            textTransform: "capitalize",
            ...FONTS.Bold16,
            color: Colors.primary,
          }}
        >
          Select Slug
        </BoldHeading>
        <CustomSelect
          value={formik?.values?.slug}
          onChange={handleSlug}
          placeholder={"Select Slug"}
          options={slugOptions}
          mainStyle={styles.mainStyle}
        />
        {getError("slug") && (
          <CustomText
            style={{ color: Colors.redColor, marginTop: -8 }}
            text={getError("slug")}
          />
        )}
        {(formik.values.paid || course?.paid) && (
          <MasKInput
            text={"Course Fee"}
            name="price"
            placeholder="Enter Course Fee"
            onBlur={formik.handleBlur}
            mainStyle={styles.mainStyle}
            error={getError("price")}
            value={formik.values.price}
            style={{ marginRight: 10 }}
            mask="9999.9999"
            onChangeText={(name, e) => formik.setFieldValue(name, +e)}
          />
        )}
        <MasKInput
          text={"Description"}
          name="description"
          placeholder="Description"
          onBlur={formik.handleBlur}
          mainStyle={styles.mainStyle}
          error={getError("description")}
          value={formik.values.description}
          style={{ marginRight: 10 }}
          onChangeText={(name, e) => formik.setFieldValue(name, e)}
        />
        <MasKInput
          text={"Prerequisites"}
          name="prerequisite"
          placeholder="Prerequisites"
          onBlur={formik.handleBlur}
          mainStyle={styles.mainStyle}
          error={getError("prerequisite")}
          value={formik.values.prerequisite}
          style={{ marginRight: 10 }}
          maxLength={20}
          onChangeText={(name, e) => formik.setFieldValue(name, e)}
        />
        <MasKInput
          text={"Certificate"}
          name="certificate"
          placeholder="Certificate"
          onBlur={formik.handleBlur}
          mainStyle={styles.mainStyle}
          error={getError("certificate")}
          value={formik.values.certificate}
          style={{ marginRight: 10 }}
          maxLength={20}
          onChangeText={(name, e) => formik.setFieldValue(name, e)}
        />
        <MasKInput
          text={"Credit Hours"}
          mask="99.9"
          name="credit_hours"
          placeholder="Credit Hours"
          onBlur={formik.handleBlur}
          mainStyle={styles.mainStyle}
          error={getError("credit_hours")}
          value={formik.values.credit_hours}
          style={{ marginRight: 10 }}
          onChangeText={(name, e) => formik.setFieldValue(name, +e)}
        />
        <MasKInput
          text={"Start Date"}
          name="start_date"
          placeholder="Start Date"
          onBlur={formik.handleBlur}
          mainStyle={styles.mainStyle}
          error={getError("start_date")}
          style={{ marginRight: 10 }}
          value={
            formik.values.start_date
              ? dayjs(formik.values.start_date).format("DD MMM YYYY")
              : ""
          }
          onChangeText={(name, e) => formik.setFieldValue(name, e)}
          readOnly
          rightIcon={images.calendar}
          rightIconPress={() => openModal("start")}
        />
        <MasKInput
          text={"End Date"}
          name="end_date"
          placeholder="End Date"
          onBlur={formik.handleBlur}
          mainStyle={styles.mainStyle}
          error={getError("end_date")}
          style={{ marginRight: 10 }}
          value={
            formik.values.end_date
              ? dayjs(formik.values.end_date).format("DD MMM YYYY")
              : ""
          }
          onChangeText={(name, e) => formik.setFieldValue(name, e)}
          readOnly
          rightIcon={images.calendar}
          rightIconPress={() => openModal("end")}
        />

        <BoldHeading
          style={{
            textTransform: "capitalize",
            ...FONTS.Bold16,
            color: Colors.primary,
          }}
        >
          Select Folder
        </BoldHeading>
        <CustomSelect
          value={formik?.values?.folder_name}
          onChange={handleFolder}
          placeholder={"Select Folder"}
          options={folderOptions}
          mainStyle={styles.mainStyle}
        />
        {getError("folder_name") && (
          <CustomText
            style={{ color: Colors.redColor, marginTop: -8 }}
            text={getError("folder_name")}
          />
        )}

        {!formik.values.paid && (
          <div
            style={{
              ...STYLES.HorizontalAlign,
              justifyContent: "space-between",
            }}
          >
            <div style={STYLES.HorizontalAlign}>
              <input
                type="checkbox"
                style={{ width: 15, height: 15, marginRight: 10 }}
                checked={formik.values.auto_enrollment}
                onChange={() =>
                  formik.setFieldValue(
                    "auto_enrollment",
                    !formik.values.auto_enrollment
                  )
                }
              />
              <CustomText
                style={{ color: Colors.primary }}
                text={"I allow student to enroll directly in the course"}
              />
            </div>
            <div></div>
          </div>
        )}
      </DetailView>
      <HorizontalLeftAlign
        style={{
          position: "absolute",
          bottom: 20,
          backgroundColor: "#fff",
          width: "50%",
        }}
      >
        <IconButton
          onClick={formik.handleSubmit}
          text={course?.id ? "Confirm" : "Send for Approval"}
          style={{ width: 150, borderRadius: 5, marginRight: 10 }}
          textStyle={{ fontWeight: "500" }}
          loading={courseLoading}
          disabled={courseLoading}
          // disabled={course?.id ? false : !(formik.isValid && formik.dirty)}
        />
        {course?.id ? (
          <IconButton
            onClick={handleBack}
            text={"Cancel"}
            style={{
              width: 150,
              borderRadius: 5,
              marginRight: 10,
              backgroundColor: "#fff",
              border: `1px solid ${Colors.primary}`,
            }}
            textStyle={{ color: Colors.primary, fontWeight: "400" }}
            // disabled={!(formik.isValid && formik.dirty)}
          />
        ) : (
          <Dropdown
            disabled={courseLoading}
            items={adminList}
            buttonText="Send To"
            buttonStyle={{ width: 100, borderRadius: 5, marginRight: 10 }}
            buttonTxtStyle={{ fontWeight: "500" }}
            onItemClick={onSelectAdmin}
            multiSelect
            position={"top"}
            alignment={"left"}
          />
        )}
      </HorizontalLeftAlign>
      {openCalendar?.isOpen && (
        <CalendarComponent
          openCalendar={openCalendar?.isOpen}
          closeModal={closeModal}
          date={
            openCalendar?.type === "start_date"
              ? formik.values?.start_date
              : formik.values?.end_date
          }
          onChange={handleDate}
          minDate={new Date()}
        />
      )}
      {openPopup?.isOpen && (
        <ModalComponent
          closeModal={closeModal}
          openModal={openPopup?.isOpen}
          heading={`Send request for approval to`}
          yesBtnTxt={"Send "}
          noBtnTxt={"Cancel"}
          yesBtn={sendTo}
          noBtn={closeModal}
        >
          <div>
            {openPopup?.item.map((each) => (
              <>
                <p style={{ ...FONTS.Bold13 }}>
                  {each?.username.toUpperCase()}
                </p>
                <p style={{ ...FONTS.Regular13, marginTop: -5 }}>
                  {each?.email}
                </p>
              </>
            ))}
          </div>
        </ModalComponent>
      )}
     
      {openPopup?.addImg && (
        <ModalComponent
          heading={"Upload Course Banner"}
          openModal={openPopup?.addImg}
          closeModal={closeModal}
        >
          <FileUploader
            handleChange={handleImageChange}
            name="file"
            types={fileTypes}
            maxSize={10}
            onTypeError={(e) => toast.error(e)}
            onSizeError={(e) => toast.error(e)}
          />
        </ModalComponent>
      )}
    </Container>
  );
};

export default NewCourse;
